import { Skeleton } from 'antd';
import React from 'react';

import { ByItem } from '@/pages/security/comps/ByList';

const Item = () => {
  return (
    <ByItem>
      <div className="accountInfo-auth-container">
        <div className="accountInfo-auth-container-column">
          <Skeleton.Avatar
            style={{
              height: '32px',
              width: '32px',
              marginRight: '12px',
            }}
            active={true}
            size={'small'}
            shape="circle"
          />
          <Skeleton.Button
            active={true}
            style={{
              height: '32px',
              width: '124px',
            }}
            size={'small'}
            shape={'square'}
            block={true}
          />
        </div>
        <div className="accountInfo-auth-container-content">
          <div>
            <Skeleton.Button
              active={true}
              style={{
                height: '18px',
                width: '125px',
                marginBottom: '4px',
              }}
              size={'small'}
              shape={'square'}
              block={true}
            />
          </div>
          <div className="accountInfo-auth-container-content-last text-special-color">
            <Skeleton.Button
              active={true}
              style={{
                height: '18px',
                width: '437px',
              }}
              size={'small'}
              shape={'square'}
              block={true}
            />
          </div>
        </div>
        <div className="accountInfo-auth-container-operation">
          <div>
            <Skeleton.Button
              active={true}
              style={{
                height: '48px',
                width: '135px',
              }}
              size={'small'}
              shape={'square'}
              block={true}
            />
          </div>
        </div>
      </div>
    </ByItem>
  );
};

export const GroupItem = () => {
  return (
    <>
      <Item></Item>
      <Item></Item>
      <Item></Item>
    </>
  );
};

export default GroupItem;
